import React from 'react';
import { authColors } from '../../styles/colors';

interface AuthLayoutProps {
  children: React.ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className={`min-h-screen ${authColors.backgroundGradient} flex flex-col px-4 sm:px-6 lg:px-8 relative`}>
      <div className="flex-1 flex flex-col justify-center py-6 sm:py-10">
        <div className="mx-auto w-full max-w-md">
          {children}
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;

